<div class="start-sesion-wrapper">
  <p class="session-title">Ya hay una sesión abierta</p>
  <p class="session-body">¿Quieres continuar o cerrar la sesión actual y empezar una nueva?</p>
  <div class="session-actions">
    <button class="btn-secondary" (click)="continueSession()">Continuar</button>
    <button class="btn-action" (click)="newSession()">Nueva sesión</button>
  </div>
</div>